interface SectionHeadingProps {
  kicker: string;
  title: string;
  desc?: string;
  tone?: "light" | "dark";
}

export default function SectionHeading({ kicker, title, desc, tone = "light" }: SectionHeadingProps) {
  const isDark = tone === "dark";
  return (
    <div className="flex flex-col gap-3 md:flex-row md:items-end md:justify-between">
      <div>
        <div className="flex items-center gap-3">
          <span className="h-px w-8 bg-accent-500" />
          <span
            className={`font-label text-xs uppercase tracking-[0.35em] ${
              isDark ? "text-accent-400" : "text-primary-600"
            }`}
          >
            {kicker}
          </span>
        </div>
        <h4 className="mt-3 font-heading text-2xl font-bold text-foreground-950 md:text-4xl">
          <a href="#top" className="transition-colors hover:text-primary-600">
            {title}
          </a>
        </h4>
      </div>
      {desc && (
        <p
          className={`mt-2 max-w-md text-sm leading-relaxed md:mt-0 md:text-right ${
            isDark ? "text-background-300" : "text-foreground-600"
          }`}
        >
          {desc}
        </p>
      )}
    </div>
  );
}